<script setup>
import { useStore } from "vuex";
import RegistrationProgress from "../../../views/login/registration/components/RegistrationProgress.vue";
import CustomerForm from "../../../views/login/registration/forms/CustomerForm.vue";
import RegistrationIcons from "../../../views/login/registration/components/RegistrationIcons.vue";
import {computed} from "vue";
import AgencyStripeForm from "./AgencyStripeForm.vue";

const props = defineProps({
  preview: {
    type: Boolean,
    default: false,
  },
  countries: {
    type: Object,
    required: true,
  },
});

const store = useStore();

const stageIsPaymentInformation = computed(() => {
  return store.getters['registration/stage'] === 'PAYMENT_INFORMATION';
});
</script>

<template>
  <RegistrationProgress
    :reseller="true"
    :completed="stageIsPaymentInformation"
  />
  <div
    v-if="stageIsPaymentInformation"
    class="back-to-details"
    @click="store.dispatch('registration/setStage', 'CUSTOMER_INFORMATION')"
  >
    <p><i class="arrow" /> back to details</p>
  </div>
  <div class="form-container">
    <div class="form">
      <CustomerForm
        v-if="store.getters['registration/stage'] === 'CUSTOMER_INFORMATION'"
        :preview="props.preview"
        :countries="props.countries"
        :is-reseller="true"
      />
      <AgencyStripeForm v-if="stageIsPaymentInformation" />
    </div>
    <RegistrationIcons
      :stage="store.getters['registration/stage']"
    />
  </div>
</template>

<style scoped>
.back-to-details {
  align-self: normal;
  cursor: pointer;
}

.form-container {
  display: flex;
  width: 100%;
  gap: 3rem;
}

.form {
  display: flex;
  flex: 1;
  flex-direction: column;
  background: #FFFFFF;
  gap: 1rem;
}

.form-navigation {
  display: flex;
  width: 100%;
  justify-content: flex-start;
}

.form-navigation p {
  cursor: pointer;
}

.arrow {
  border: solid black;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(135deg);
}

@media only screen and (max-width: 900px) {
  .form-container {
    flex-direction: column;
  }
}
</style>
